export enum VIEWS {
  MAP = 'map-view',
  TABLE = 'table-view',
}

export const VIEW_STRINGS = {
  [VIEWS.MAP]: _TL_('Map'),
  [VIEWS.TABLE]: _TL_('List'),
};

export const LOCATIONS_PER_PAGE = 5;

export const BUBBLE_MAX_RADIUS = 25;
export const BUBBLE_MIN_RADIUS = 6;

export const locationGranularity = {
  country: {
    name: 'CountryName',
    longitude: 'CountryLongitude',
    latitude: 'CountryLatitude',
  },
  county: {
    name: 'CountyName',
    longitude: 'CountyLongitude',
    latitude: 'CountyLatitude',
  },
  stateOrProvince: {
    name: 'StateOrProvince',
    longitude: 'SubGeographyLongitude',
    latitude: 'SubGeographyLatitude',
  },
  city: {
    name: 'City',
    longitude: 'CityLongitude',
    latitude: 'CityLatitude',
  },
  postalCode: {
    name: 'PostalCode',
    longitude: 'PostalCodeLongitude',
    latitude: 'PostalCodeLatitude',
  },
};

export const METRIC_STRINGS = {
  Clicks: _TL_('Clicks'),
  Impressions: _TL_('Impr.'),
  CTR: _TL_('CTR'),
  AverageCPC: _TL_('Avg. CPC'),
  Spend: _TL_('Spend'),
  TopImpressionRatePercent: _TL_('Top impr. rate'),
  AbsoluteTopImpressionRatePercent: _TL_('Abs. top impr. rate'),
  ConversionsCredit: _TL_('Conv.'),
  PartialConversionRate: _TL_('Conv. rate'),
  PartialConversionCPA: _TL_('CPA'),
  AdvertiserReportedRevenue: _TL_('Revenue'),
  RevenueOnAdSpend: _TL_('Revenue on ad spend'),
};

export const METRIC_FULL_STRINGS = {
  Clicks: _TL_('Clicks'),
  Impressions: _TL_('Impressions'),
  CTR: _TL_('CTR'),
  AverageCPC: _TL_('Average CPC'),
  Spend: _TL_('Spend'),
  TopImpressionRatePercent: _TL_('Top impression rate'),
  AbsoluteTopImpressionRatePercent: _TL_('Absolute top impression rate'),
  ConversionsCredit: _TL_('Conversions'),
  PartialConversionRate: _TL_('Conversion rate'),
  PartialConversionCPA: _TL_('CPA'),
  AdvertiserReportedRevenue: _TL_('Revenue'),
  RevenueOnAdSpend: _TL_('Revenue on ad spend'),
};
